<template>
  <div v-show="relatedProducts.length" class="mt-6 print:mx-0 md:mx-0">
    <h3 class="mb-12 pr-16 text-lg md:pr-4 md:text-2xl">
      {{ $t("shared.catalog.product_details.related_products") }}
    </h3>
    <VcCarousel
      :slides="relatedProducts"
      :options="relatedProductsCarouselOptions"
      navigation
      class="mb-8 [--navigation-offset:3rem] lg:mb-2"
    >
      <template #slide="{ slide: item }">
        <InnoCarouselProductCard :product="item" class="mb-6" />
      </template>
    </VcCarousel>
  </div>
</template>

<script setup lang="ts">
import { InnoCarouselProductCard } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";
import type { PropType } from "vue";

defineProps({
  relatedProducts: {
    type: Array as PropType<Product[]>,
    required: true,
  },

  model: {
    type: Object,
    required: true,
  },

  isMobile: {
    type: Boolean,
  },
});

const relatedProductsCarouselOptions: ICarouselOptions = {
  spaceBetween: 30,
  slidesPerView: 1,
  breakpoints: {
    768: /* md */ {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
};
</script>
